export default {
  tabs: {
    home: 'Accueil',
    menu: 'Menu',
    orders: 'Commandes',
  },
};
